/**
 * @description Componente principal do modo interno
 * @module FluxVetDashboard
 * @since Fevereiro 2024
 */

import React from "react";
import { Box, CircularProgress, Stack } from "@mui/material";

import "dayjs/locale/pt-br";
import VetAppointments from "@/fluxvet/components/VetAppointments";
import VetQuickAccess from "@/fluxvet/components/VetQuickAccess";
import MyPets from "@/fluxvet/components/MyPets";
import { WelcomeMessage } from "@/fluxvet/components/WelcomeMessage";
import { useSessionContext } from "@/contexts/SessionContext";
import { PatientQuestionnaireTasksSection } from "@/pages/home/components/PatientDash/components/PatientQuestionnaireTasksSection";

const FluxVetDashboard: React.FC = () => {
  const { user, loading } = useSessionContext();

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <WelcomeMessage userName={user?.name?.split(" ")[0]} />
      <MyPets />
      {/* Tutor responde questionários dos pets (sem consentimento; ver PatientQuestionnaireTasksSection). */}
      <Stack spacing={2} sx={{ mt: 2, mb: 2 }}>
        <PatientQuestionnaireTasksSection variant="tutor" />
      </Stack>
      <VetAppointments />
      <VetQuickAccess />
    </Box>
  );
};

export default FluxVetDashboard;
